import { Button, CircularProgress } from '@mui/material';

import Stack from '@/components/Stack';
import { Small } from '@/components/Typography';

type Props = {
  shown: number;
  total: number;
  hasMore: boolean;
  loadingMore: boolean;
  error: string | null;
  onLoadMore: () => void;
};

// BH-67: below the audit log table, while older rows are still on the server.
const AuditLogsMore = ({
  shown,
  total,
  hasMore,
  loadingMore,
  error,
  onLoadMore,
}: Props) => {
  if (!hasMore) return null;
  return (
    <Stack
      data-testid="auditLogsMore"
      gap={12}
      style={{ justifyContent: 'center', padding: '12px 0' }}
    >
      <Small color="lighter" data-testid="auditLogsShowing">
        Showing {shown} of {total}
      </Small>
      <Button
        disabled={loadingMore}
        onClick={onLoadMore}
        size="small"
        variant="outlined"
      >
        {loadingMore ? <CircularProgress size={16} /> : 'Load more'}
      </Button>
      {error && (
        <Small color="danger" role="alert">
          {error}
        </Small>
      )}
    </Stack>
  );
};

export default AuditLogsMore;
